import { FolderInfoGroup } from '@/modules/drive/domain/models/GetFolderInfo'

import { axios, Response } from '../index'

export interface PersonaAccessInfo {
  folderId: string
  folderPersonPermissionId: string
  permissionInsideFolder: 'EDIT' | 'VISUALIZATION'
  personaInfoSummary: PersonaInfoSummary
  accessProfilePermissions: AccessProfilePermission[]
}

export interface AccessProfilePermission {
  id: string
  profile: Profile
  permissionInsideFolder: string
}

export interface Profile {
  id: number
  name: string
  personaType: string
}

export interface PersonaInfoSummary {
  userId: string
  username: string
  avatarUrl: string
}

const getFolderShareOptions = (
  folderId: string
): Response<FolderInfoGroup[]> => {
  return axios.get(`/v1/folders/${folderId}/personas-permissions`)
}

export default getFolderShareOptions
